module.exports = "\n\n<p class=\"paragraph-second-part\" [innerHTML]=\"getText()\"></p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-supply-invoice-reception-management/alg-supply-invoice-reception-info-subscription/alg-supply-invoice-reception-info-subscription.component.html
// module id = ./src/app/components/alg-supply-invoice-reception-management/alg-supply-invoice-reception-info-subscription/alg-supply-invoice-reception-info-subscription.component.html
// module chunks = main